import React from 'react'
import { Button, Menu, MenuItem, makeStyles } from '@material-ui/core'
import { KeyboardArrowDown } from '@material-ui/icons'

interface IMonthPicker {
  value: string
  setValue: (value: string) => void
}

const getMonths = () => {
  return [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]
}

const months = getMonths()

const useStyles = makeStyles({
  button: {
    color: '#FFF'
  },
  menu: {
    marginTop: 60
  }
})

export const MonthPicker = (props: IMonthPicker) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const classes = useStyles()

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <Button
        variant='text'
        className={classes.button}
        onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
          setAnchorEl(event.currentTarget)
        }}
        endIcon={<KeyboardArrowDown />}>
        {months[+props.value - 1] || 'Month'}
      </Button>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose} className={classes.menu}>
        {months.map((month, monthIndex) => (
          <MenuItem
            key={month}
            onClick={() => {
              props.setValue(`${monthIndex + 1}`)
              handleClose()
            }}>
            {month}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
